import { Consumer } from '@app/models/consumer';
import { Injectable } from '@angular/core';
import { computeAge } from '@app/utils/date-functions';
import { BaseAdapterService } from './base-adapter.service';

@Injectable({ providedIn: 'root' })
export class ConsumerAdapter extends BaseAdapterService<Consumer> {
  adapt(item: any): Consumer {
    const consumer = item as Consumer;

    consumer.id = Consumer.buildIdConsumer(item.idEnfant, item.idAdulte);
    consumer.idEnfant = item.idEnfant;
    consumer.idAdulte = item.idAdulte;


    if (consumer.dateNaissance && typeof consumer.dateNaissance === 'string') {
      consumer.dateNaissance = new Date(consumer.dateNaissance + 'T00:00:00.000');
      // NB : above, we must add 'T00:00:00.000' to avoid date to be considered as UTC 
      // (Otherwise clients in other timezone that the server could see a wrong date)

      consumer.age = computeAge(consumer.dateNaissance);
    } else {
      consumer.age = { years: 0, months: 0 };
    }

    return consumer;
  }
}
